import React from 'react';
import _ from 'lodash';
import { SpotWorkerInputText } from '../SpotWorkerInputText.jsx';

import { FormElement, FormListItem } from '../../CommonFormComponents';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';
import {
  WORKER_PAGE_STATUS,
  SPOT_WORKER_RESIDENCE_TYPE,
  SPOT_WORKER_TYPE,
} from '../../../utilities/constants.js';

/**
 * 入退場者種別選択
 * @param {string} selectValue
 * @param {function} onChange
 * */
const WorkerTypeInput = ({ selectValue, onChange }) => {
  const workerTypes = _.filter(SPOT_WORKER_TYPE, {
    residenceTypeId: SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT.id,
  });

  return (
    <div className='form-list-radio'>
      {_.map(workerTypes, type => {
        return (
          <div className='form-list-radio__item' key={type.id}>
            <label htmlFor={type.code} className='radio'>
              <input
                type='radio'
                id={type.code}
                name='worker_type'
                value={type.id}
                checked={selectValue == type.id}
                onChange={onChange}
              />
              <RadioButtonIcon className='icon--2x' />
              <span>{type.name}</span>
            </label>
          </div>
        );
      })}
    </div>
  );
};

/**
 * 画面 > 基本情報
 * @param {object} formValues: 表示したいデータ群
 * @param {object} messages: バリデーションエラーメッセージ群
 * @param {boolean} disabledAll: 項目を編集することができるかどうか？
 * @param {function} events: ファンクション群(setValue, validate)
 * @param {object} pageStatus
 */
export const SpotWorkerInfoForm = ({
  formValues,
  messages,
  disabledAll,
  events,
  pageStatus,
}) => {
  const workerInputTextOnChange = e => {
    events.setValue(e);
  };

  const workerInputTextOnBlur = e => {
    events.validate(e.target.name);
  };

  const residenceType =
    formValues.worker_type >= 2
      ? SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT
      : SPOT_WORKER_RESIDENCE_TYPE.RESIDENT;

  const workerTypeRadioEnabled = pageStatus === WORKER_PAGE_STATUS.NEW;

  const nameSeiLabel =
    residenceType.id === SPOT_WORKER_RESIDENCE_TYPE.RESIDENT.id
      ? 'せい'
      : 'セイ';
  const nameMeiLabel =
    residenceType.id === SPOT_WORKER_RESIDENCE_TYPE.RESIDENT.id
      ? 'めい'
      : 'メイ';

  const workerType =
    formValues.worker_type == 2
      ? SPOT_WORKER_TYPE.TEMPORARY
      : SPOT_WORKER_TYPE.GUEST;

  return (
    <React.Fragment>
      {residenceType.id === SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT.id && (
        <FormListItem label='入退場者種別' required={workerTypeRadioEnabled}>
          <FormElement>
            {workerTypeRadioEnabled ? (
              <WorkerTypeInput
                selectValue={formValues.worker_type}
                onChange={events.setValue}
              />
            ) : (
              <SpotWorkerInputText
                name='worker_type'
                value={workerType.name}
                disabled={true}
              />
            )}
          </FormElement>
        </FormListItem>
      )}
      {formValues.worker_type == SPOT_WORKER_TYPE.GUEST.id && (
        <FormListItem label='会社名' required={false}>
          <FormElement validate={messages.company_name}>
            <SpotWorkerInputText
              name='company_name'
              value={formValues.company_name}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>
      )}
      <FormListItem label='姓' required={disabledAll === false}>
        <FormElement validate={messages.name_sei}>
          <SpotWorkerInputText
            name='name_sei'
            value={formValues.name_sei}
            disabled={disabledAll}
            maxLength={255}
            onChange={workerInputTextOnChange}
            onBlur={workerInputTextOnBlur}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='名' required={disabledAll === false}>
        <FormElement validate={messages.name_mei}>
          <SpotWorkerInputText
            name='name_mei'
            value={formValues.name_mei}
            disabled={disabledAll}
            maxLength={255}
            onChange={workerInputTextOnChange}
            onBlur={workerInputTextOnBlur}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label={nameSeiLabel} required={disabledAll === false}>
        <FormElement validate={messages.name_sei_kana}>
          <SpotWorkerInputText
            name='name_sei_kana'
            value={formValues.name_sei_kana}
            disabled={disabledAll}
            maxLength={255}
            onChange={workerInputTextOnChange}
            onBlur={workerInputTextOnBlur}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label={nameMeiLabel} required={disabledAll === false}>
        <FormElement validate={messages.name_mei_kana}>
          <SpotWorkerInputText
            name='name_mei_kana'
            value={formValues.name_mei_kana}
            disabled={disabledAll}
            maxLength={255}
            onChange={workerInputTextOnChange}
            onBlur={workerInputTextOnBlur}
          />
        </FormElement>
      </FormListItem>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/spotWorker/form/SpotWorkerInfoForm.jsx